import { SWRResponse } from "swr";
import { AppRouteApi } from "../../config/appRoute";
import { AxiosAuth } from "../axios";
import {
  CreateAccessObject,
  useExtendedApiAccess,
} from "./useExtendedApiAccess";
import {
  ApiSchemaCareGiverCountByTask,
  ApiSchemaCaregiversReport,
  ApiSchemaPatientCountByInsuranceType,
} from "../../models/api/apiSuperAdminDashboard";
import { StorageAuth } from "../localStorage";
import { ApiResponseContainer, IMissingInvoiceResponse, InvoiceReportResponse, IReferralsResponse } from "../../models/api";
const CacheIds = {
  GetPatientCountByInsuranceType:
    AppRouteApi.Reporting.PatientCountByInsuranceType(),
  GetCareGiverCountByTask: AppRouteApi.Reporting.CaregiverCountByTask(),
  GetCaregiversReport: AppRouteApi.Reporting.CaregiversReport(),
  ReferralReport: AppRouteApi.Appointment.GetReferrals(),
};

function useApiInsuranceTypesGet(): SWRResponse<
  ApiSchemaPatientCountByInsuranceType[] | undefined,
  Error
> {
  return useExtendedApiAccess<ApiSchemaPatientCountByInsuranceType[]>(
    CacheIds.GetPatientCountByInsuranceType,
    () => AxiosAuth.get(CacheIds.GetPatientCountByInsuranceType)
  );
}

function useApiCaregiverCountGet(): SWRResponse<
  ApiSchemaCareGiverCountByTask[] | undefined,
  Error
> {
  const { CompanyId } = StorageAuth;
  return useExtendedApiAccess<ApiSchemaCareGiverCountByTask[]>(
    CacheIds.GetCareGiverCountByTask,
    () =>
      AxiosAuth.get(CacheIds.GetCareGiverCountByTask, {
        params: { companyId: CompanyId },
      })
  );
}

function useApiCaregiversReport(): SWRResponse<
  ApiSchemaCaregiversReport[] | undefined,
  Error
> {
  const { CompanyId } = StorageAuth;
  return useExtendedApiAccess<ApiSchemaCaregiversReport[]>(
    CacheIds.GetCaregiversReport,
    () =>
      AxiosAuth.get(CacheIds.GetCaregiversReport, {
        params: { companyId: CompanyId },
      })
  );
}

const AccessObject = {
  GetPatientCountByInsuranceType: CreateAccessObject<
    ApiSchemaPatientCountByInsuranceType[],
    typeof useApiInsuranceTypesGet
  >(CacheIds.GetPatientCountByInsuranceType, useApiInsuranceTypesGet),
  GetCaregiverCountByTask: CreateAccessObject<
    ApiSchemaCareGiverCountByTask[],
    typeof useApiCaregiverCountGet
  >(CacheIds.GetCareGiverCountByTask, useApiCaregiverCountGet),
  GetCaregiversReport: CreateAccessObject<
    ApiSchemaCareGiverCountByTask[],
    typeof useApiCaregiversReport
  >(CacheIds.GetCaregiversReport, useApiCaregiversReport),
};

export const ApiReportingTab = {
  GetPatientCountByInsuranceType: AccessObject.GetPatientCountByInsuranceType,
  GetCaregiverCountByTask: AccessObject.GetCaregiverCountByTask,
  GetCaregiversReport: AccessObject.GetCaregiversReport,
};


export function GetReferrals(payload:{fromDate:string|undefined;toDate:string|undefined;companyId:string}){
  return AxiosAuth.post<ApiResponseContainer<IReferralsResponse>>(AppRouteApi.Appointment.GetReferrals(),payload);
}

export function GetAppointmentCountWithPendingInvoice(payload:{fromDate:string|undefined;toDate:string|undefined;companyId:string}){
  return AxiosAuth.post<ApiResponseContainer<IMissingInvoiceResponse>>(AppRouteApi.Appointment.GetAppointmentCountWithPendingInvoice(),payload);
}

export function GetInvoiceReport(payload:{fromDate:string|undefined;toDate:string|undefined;companyId:string}){
  return AxiosAuth.post<ApiResponseContainer<InvoiceReportResponse>>(AppRouteApi.Appointment.GetReportByStatus(),payload);
}